import HomeTwoPrevIcon from "./home-2/HomeOnePrevIcon.svg";
import HomeTwoHeroShape from "./home-2/HomeTwoHeroShape.svg";
import HomeTwoNextIcon from "./home-2/HomeTwoNextIcon.svg";
import HomeTwoPortfolioLeftArrow from "./home-2/HomeTwoPortfolioLeftArrow.svg";
import HomeTwoPortfolioRightArrow from "./home-2/HomeTwoPortfolioRightArrow.svg";
import HomeTwoRightArrow from "./home-2/HomeTwoRightArrow.svg";
import HomeTwoHeroAreaYoutubeIcon from "./home-2/HomeTwoHeroAreaYoutubeIcon.svg";
import LinkedIn from "./icons/Linkedin.svg";
import LinkedInWide from "./brand/LinkedIn-Wide.svg"

import MobileMenuPlus from "./MobileMenuPlus.svg";
import Offcanvas2 from "./Offcanvas2.svg";
import ScrollDownArrow from "./ScrollDownArrow.svg";
import ScrollToTop from "./ScrollToTop.svg";
import Moon from "./Moon.svg";
import Sun from "./Sun.svg";
import LogoHealthline from "./brand/Healthline.svg";
import LogoZOE from "./brand/Zoe.svg";
import LogoMNT from "./brand/MNT.svg";
import LogoPhoton from "./brand/Photon.svg";
import LogoPenguinRandomHouse from "./brand/PenguinRandomHouse.svg";
import LogoMedico from "./brand/Medico.svg";
import LogoSymprove from "./brand/Symprove.svg";
import LogoFloHealth from "./brand/FloHealth.svg";

import LogoAOG from "./icons/association-of-ghostwriters.svg"
import LogoCIEP_APM from "./icons/ciep-apm.svg"

import LogoMuseHorizontal from "./logos/logo_horizontal.svg";
import LogoMuseSquareFull from "./logos/logo_square_full.svg";
import LogoMuseSquareSimple from "./logos/logo_square_simple.svg";

export const Icons = {
  MobileMenuPlus,
  Offcanvas2,
  ScrollDownArrow,
  ScrollToTop,
  Moon,
  Sun,
  LinkedIn,
  LinkedInWide,
  HomeTwoNextIcon,
  HomeTwoPrevIcon,
  HomeTwoPortfolioLeftArrow,
  HomeTwoPortfolioRightArrow,

  LogoHealthline,
  LogoMNT,
  LogoMedico,
  LogoPenguinRandomHouse,
  LogoPhoton,
  LogoZOE,
  LogoSymprove,
  LogoFloHealth,

  LogoAOG,
  LogoCIEP_APM,

  LogoMuseHorizontal,
  LogoMuseSquareFull,
  LogoMuseSquareSimple,
};
export type IconNames = keyof typeof Icons;

export interface IconProps {
  className?: string;
  color?: string;
  width?: string;
  height?: string;
  name: IconNames;
  onClick?: () => void;
}

export const Icon: React.FC<IconProps> = (props: IconProps) => {
  if (!(props.name in Icons)) {
    return null;
  }

  const IconComponent = Icons[props.name];

  const widthStyles = props.width
    ? { display: "block", width: props.width }
    : {};
  

  return (
    <span
      className={props.className}
      onClick={props.onClick}
      style={{ color: props.color, ...widthStyles }}
    >
      {IconComponent.length && <IconComponent />}
    </span>
  );
};
